// The named text colours (Features 1, 20 Oct): words a person or an agent colours in a page. A short set of names,
// never a hex code, so each theme draws its own readable shade of each (src/themes/themes.ts, --tc-<name>), and an
// agent writes them as <span data-color="orange">…</span> in a page's Markdown.

export const TEXT_COLORS = ["red", "orange", "yellow", "green", "blue", "purple", "grey"] as const;
export type TextColor = (typeof TEXT_COLORS)[number];

export const TEXT_COLOR_NAMES: Record<TextColor, string> = { red: "Red", orange: "Orange", yellow: "Yellow", green: "Green", blue: "Blue", purple: "Purple", grey: "Grey" };

/** One of the names, from what was written ("Orange", "gray"), or null. */
export function textColor(raw: unknown): TextColor | null {
  if (typeof raw !== "string") return null;
  const k = raw.trim().toLowerCase().replace(/^gray$/, "grey");
  return (TEXT_COLORS as readonly string[]).includes(k) ? (k as TextColor) : null;
}

/** Each name's starting shade on a dark and on a light theme; a theme moves it until it reads on its own surface. */
export const TEXT_COLOR_BASE: Record<"dark" | "light", Record<TextColor, string>> = {
  dark: { red: "#ff7b72", orange: "#ffa657", yellow: "#f2cc60", green: "#7ee787", blue: "#79c0ff", purple: "#d2a8ff", grey: "#a3a9b1" },
  light: { red: "#cf222e", orange: "#bc4c00", yellow: "#8a5d00", green: "#1a7f37", blue: "#0969da", purple: "#8250df", grey: "#636c76" },
};
